import {
  FETCHING_AGENTS,
  FETCHING_AGENTS_SUCCESS,
  FETCHING_AGENTS_FAILED,
  RESETTING_AGENT_PASSWORD,
  RESETTING_AGENT_PASSWORD_SUCCESS,
  RESETTING_AGENT_PASSWORD_FAILED
} from '../../utils/types';

const initialState = {
  agents: [],
  meta: { page: 1, limit: 10, total: 0, totalPages: 0 },
  loadingAgents: false,
  agentsError: false,
  resettingPassword: false
};

export default function agentsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_AGENTS:
      return { ...state, loadingAgents: true, agentsError: false };
    case FETCHING_AGENTS_SUCCESS:
      return { ...state, loadingAgents: false, agents: action.data, meta: action.meta };
    case FETCHING_AGENTS_FAILED:
      return { ...state, loadingAgents: false, agentsError: true };
    case RESETTING_AGENT_PASSWORD:
      return { ...state, resettingPassword: true };
    case RESETTING_AGENT_PASSWORD_SUCCESS:
      return { ...state, resettingPassword: false };
    case RESETTING_AGENT_PASSWORD_FAILED:
      return { ...state, resettingPassword: false };
    default:
      return state;
  }
}
